import {
    PermissionEnum,
    SiteRecceTypeEnum,
    SiteReccePriorityEnum,
    SiteRecceStatusEnum,
    SiteRecceTypeLabels,
    SiteReccePriorityLabels,
    SiteRecceStatusLabels,
} from '@api/enum';
import useAuthPermission from '@hooks/use-auth-permission';
import { Table } from '@hyperflake/react-ui-library';
import { Chip } from '@library/chip';
import { useSiteRecceListData } from 'modules/site-recce/hooks/useSiteRecceListData';
import moment from 'moment';
import { useNavigate, useParams } from 'react-router-dom';

export const SiteRecceList = () => {
    const { clientInstallationId, projectInstallationId } = useParams();
    const { hasPermission } = useAuthPermission();
    const navigate = useNavigate();

    const { siteRecceList, isLoading } = useSiteRecceListData(clientInstallationId, projectInstallationId);
    return (
        <Table
            className="mt-6"
            borderStyle="divider"
            hover
            isLoading={isLoading}
            data={siteRecceList}
            columns={[
                {
                    header: 'ID',
                },
                // {
                //     header: 'Remarks',
                // },
                {
                    header: 'Type',
                },
                {
                    header: 'Priority',
                },

                {
                    header: 'Created At',
                },
                {
                    header: 'Created By',
                },
                {
                    header: 'Status',
                },
            ]}
            renderRow={(row) => (
                <Table.Row
                    key={row._id}
                    onClick={() => {
                        hasPermission(PermissionEnum.SITE_RECCE_UPDATE)
                            ? navigate(
                                  `/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/recce/${row._id}/edit`
                              )
                            : null;
                    }}
                >
                    <Table.Cell>
                        {
                            // <Link
                            //     to={`/clients/${row._id}/client-details`}
                            //     // to=""
                            //     // /clients/10212/projects/21091/cctv-cameras/98673426/edit-cctv
                            // >
                            //     <div className="text-primary">{row._id}</div>
                            // </Link>
                            <div className="text-primary">
                                {row._id}
                                {/* <Link to={`/client-installations/add`}>{row._id}</Link> */}
                            </div>
                        }
                    </Table.Cell>
                    <Table.Cell>
                        {row.type
                            ? row.type
                            : // <Chip
                              //     label={SiteRecceTypeLabels[row.type]}
                              //     color={
                              //         row.type === SiteRecceTypeEnum.INITIAL_SITE_SURVEY
                              //             ? 'primary'
                              //             : row.type === SiteRecceTypeEnum.INSTALLATION
                              //             ? 'warning'
                              //             : row.type === SiteRecceTypeEnum.REMOVAL
                              //             ? 'danger'
                              //             : 'success'
                              //     }
                              //     variant="outlined"
                              // />
                              '-'}
                    </Table.Cell>
                    {/* <Table.Cell>
                        <div className="overflow-hidden text-ellipsis">{row?.remarks}</div>
                    </Table.Cell> */}
                    <Table.Cell>
                        <Chip
                            label={SiteReccePriorityLabels[row.priority]}
                            color={
                                row.priority === SiteReccePriorityEnum.HIGH
                                    ? 'danger'
                                    : row.priority === SiteReccePriorityEnum.MEDIUM
                                    ? 'warning'
                                    : 'success'
                            }
                            variant="shaded"
                        />
                    </Table.Cell>

                    <Table.Cell>{moment(row?.createdAt, 'YYYYMMDD').format('DD MMM, YYYY')}</Table.Cell>
                    <Table.Cell>{row?.createdBy?.name || '-'}</Table.Cell>
                    <Table.Cell>
                        {row.status}
                        {/* <Chip
                            label={SiteRecceStatusLabels[row.status]}
                            color={
                                row.status === SiteRecceStatusEnum.UNASSIGNED
                                    ? 'secondary'
                                    : row.status === SiteRecceStatusEnum.ASSIGNED
                                    ? 'warning'
                                    : row.status === SiteRecceStatusEnum.COMPLETED
                                    ? 'success'
                                    : 'danger'
                                // : 'success'
                            }
                            variant="outlined"
                        /> */}
                    </Table.Cell>
                </Table.Row>
            )}
        />
    );
};
